import defaultLayout from './../../../layouts/default/default.vue'
import teamService from './../../../services/team'
import hofService from './../../../services/hof'
import store from './../../../store'
import {includes} from 'lodash'
import {mapGetters} from 'vuex'

export default {
  components: {
    VLayout: defaultLayout,
  },

  created () {
    store.dispatch('fetchPersons')
    hofService.find()
    teamService.find(this.teamId)
  },

  destroyed () {
    store.dispatch('getTeam', {})
  },

  data () {
    return {
      memberNumber: 0,
    }
  },

  computed: {
    ...mapGetters([
      'getPerson',
    ]),
    team () {
      return store.state.team.get
    },
    hof () {
      return store.state.hof.all
    },
    teamId () {
      return this.$route.params.teamId
    },
    hofTeam() {
      return store.getters.getHofTeam(this.team.teamName) || {id: 0}
    }
  },

  watch: {
    teamId (teamId) {
      teamService.find(teamId)
    },
  },

  methods: {
    isCaptain (athleteId) {
      return includes(store.state.team.get.captains, athleteId)
    },
    isHallOfFame (athleteId) {
      return includes(store.state.hof.all.athletes, athleteId)
    },
    isInHallOfFame (team) {
      return includes(store.state.hof.all.teams, team.teamName)
    },
    getMemberNumber (rowNumber, memberNumber) {
      if (store.state.team.get.order !== 'Team members listed front row to back row, left to right.') {
        return
      }
      let rowStartsAt = []
      let startsAt = 0
      store.state.team.get.members_rows.forEach((row, rowNumber) => {
        startsAt += row.length
        rowStartsAt[rowNumber] = startsAt
      })
      rowStartsAt = rowStartsAt[rowNumber - 1] || 0
      const number = rowStartsAt + (memberNumber + 1)
      return `${number}. `
    },
  },
}
